import { Injectable } from '@angular/core';
declare const gapi: any;
declare const google: any;
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
  })
  export class GoogleDriveService {
   
    CLIENT_ID = '';
    API_KEY = '';
    APP_ID = '';
    tokenClient: any;
    intializeGPicker = false;
    intializeGApiClient = false;
    gisInited = false;
    accessToken = null;
    document = null;
    pickerCallback = null;
   
    _gapi = gapi;
    _google = google;

    constructor() {
      this.init();
    }
  
    init(){
      this.CLIENT_ID = environment.gDriveClientId;
      this.API_KEY = environment.gDriveApiKey;
      this.APP_ID = environment.gDriveAppId;
      gapi.load('picker', { 'callback': this.intializePicker.bind(this) });
      gapi.load('client', { 'callback': this.initializeGapiClient.bind(this) });
      this.gisLoaded();
    }
  
    public open(callback: any): void {
      this.pickerCallback = callback;
      this.openPicker();
    }
   
    intializePicker() {
      this.intializeGPicker = true;
    }
  
    async initializeGapiClient() {
      await gapi.client.init({
        apiKey: this.API_KEY,
        discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'],
      });
      this.intializeGApiClient = true;
    }
  
    async openPicker() {
      if (this.intializeGPicker && this.gisInited && this.intializeGApiClient) {
        let data = this._gapi.auth.getToken() === null ? null : this._gapi.auth.getToken(); 
        if(data === null){
          this.handleAuthClick();
        }
        else{
          await this.createPicker();
        }
      }else{
        console.error("Google Drive js not loaded")
      }
    }
  
    /**
     * Callback after Google Identity Services are loaded.
     */
    gisLoaded() {
      this.tokenClient = google.accounts.oauth2.initTokenClient({
        client_id: this.CLIENT_ID,
        scope: 'https://www.googleapis.com/auth/drive.readonly',
        callback: '', // defined later
      });
      this.gisInited = true;
    }
  
  
  
    /**
     *  Sign in the user upon button click.
     */
    handleAuthClick() {
      this.tokenClient.callback = async (response: any) => {
        if (response.error !== undefined) {
          throw (response);
        }
        this.accessToken = response.access_token;
        await this.createPicker();
      };
  
      if (this.accessToken === null) {
        // Prompt the user to select a Google Account and ask for consent to share their data
        // when establishing a new session.
        this.tokenClient.requestAccessToken({ prompt: 'consent' });
      } else {
        // Skip display of account chooser and consent dialog for an existing session.
        this.tokenClient.requestAccessToken({ prompt: '' });
      }
    }
  
    /**
     *  Sign out the user upon button click.
     */
    handleSignoutClick() {
      if (this.accessToken) {
        this.accessToken = null;
        google.accounts.oauth2.revoke(this.accessToken);
      }
    }
  
    /**
     *  Create and render a Picker object for searching images.
     */
    createPicker() {
      const view = new google.picker.View(google.picker.ViewId.DOCS);
      view.setMimeTypes('application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.google-apps.folder')
      const picker = new google.picker.PickerBuilder()
        .enableFeature(google.picker.Feature.NAV_HIDDEN)
        .enableFeature(google.picker.Feature.MINE_ONLY)
        .setDeveloperKey(this.API_KEY)
        .setAppId(this.APP_ID)
        .setOAuthToken(this.accessToken)
        .addView(view)
        .setCallback(this.pickerCallback)
        .build();
      picker.setVisible(true);
    }
  
    
  }